import { render, staticRenderFns } from "./PhotoPass.vue?vue&type=template&id=18628d0c"
import script from "./PhotoPass.vue?vue&type=script&lang=js"
export * from "./PhotoPass.vue?vue&type=script&lang=js"
import style0 from "./PhotoPass.vue?vue&type=style&index=0&id=18628d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports